export const ANALYTICS_CONSTANTS = {
  LIFE: {
    EAP: {
      MODALITIES: {
        GETSUPPORT: {
          CLICKED: {
            ITEM_NAME: {
              CARENOW: 'carenow',
              CHAT: 'chat',
              ONLINE_SCHEDULING: 'online-scheduling',
              PHONE_NUMBER: 'phone-number',
              SUPPORT_AND_RESOURCES: 'support-and-resources',
              CARENOW_COUNSELLOR_ASSISTED: 'carenow-counsellor-assisted',
              WORK_LIFE_SERVICES: 'work-life-services',
            },
          },
        },
        GETSUPPORTINITIATE: {
          CLICKED: {
            ITEM_NAME: {
              CARENOW_COUNSELLOR_ASSISTED: 'carenow-counsellor-assisted',
            },
          },
        },
      },
      QUICKLINK: {
        CLICKED: {
          ITEM_TYPE: {
            FEATURED: 'featured',
            NORMAL: 'normal',
            PARTNER: 'partner',
          },
        },
      },
    },
  },
} as const;
